import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { capitalizeString } from 'helpers/Utils';
import GlobalStyle from '@bit/knotchinc.web-react-components.global-style';
import PerfectScrollbarStyle from '@bit/knotchinc.web-react-components.perfect-scrollbar-style';
import BlueprintTheme from 'blueprint/js/BlueprintTheme.js';
import Text from '@bit/knotchinc.web-react-components.text';
import Box from '@bit/knotchinc.web-react-components.box';
import Mixpanel from 'helpers/Mixpanel.js';
import { SideNav } from '@bit/knotchinc.web-react-components.side-nav';
import AccountDropDown from 'components/BlueprintNav/AccountDropDown.jsx';
import { NoProductsPageContainer } from './styled';

class NoProductsPage extends Component {
  componentDidMount() {
    Mixpanel.track('view No Products Page');
  }

  render() {
    const { name, products, logOutPath } = this.props;

    const productList = products.map(product => <a href={`/${product}`}><Text>{`Knotch ${capitalizeString(product)}`}</Text></a>);
    return (
      <ThemeProvider theme={BlueprintTheme}>
        <GlobalStyle />
        <PerfectScrollbarStyle />
        <SideNav product="blueprint">
          <AccountDropDown hideSettings products={products} />
        </SideNav>
        <NoProductsPageContainer>
          <Box fontSize="15px">
            <Text fontWeight="thin" fontSize="40px">Hmm...</Text>
            <Box mt="24px" mb="24px">
              {`It looks like ${name} doesn't have access to this product.`}
              <br />
              {products.length ?
                <Box pt="2px" mb="40px" lineHeight="30px">
                  <Text mb="6px">Here's some products you have access to:</Text>
                  <Box>
                    {productList}
                  </Box>
                </Box>
              : null}
              If this sounds like a mistake or you’d like to sign up to Knotch, please contact <a href="mailto:sales@knotch.com">sales@knotch.com</a>.
            </Box>
            <Link className="backtoMain" to={logOutPath}>Click here to log out →</Link>
          </Box>
        </NoProductsPageContainer>
      </ThemeProvider>
    );
  }
}

const mapStateToProps = ({
  Account: { data: { products, name } },
}) => ({
  name,
  products,
});

export default connect(mapStateToProps)(NoProductsPage);
